export const blockIconsEditorTableRows = (
	<span className='material-symbols-outlined'>table_rows</span>
);
